// import { createTheme } from '@mui/material/styles';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#A32A29',
//     },
//     secondary: {
//       main: '#FFBA00',
//     },
//     tertuary: {
//       main: '#424039',
//     },
//     background: {
//       main: '#EEEEEE'
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// });

// export default theme;
export const primaryColor = "#A32A29";
export const secondaryColor = "#363636de";
